const FullMonths = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ]

const formatDate = (dateString = '', format: 'fullmonth' | '/' | 'shortMonth' | 'datetime' = '/') => {
    /** Get timezone offset  */
    let date = new Date(dateString)
    let offset = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
    
    /** Format date structure  */
    let day = `${offset.getDate()}`.length === 1 ? `0${offset.getDate()}` : `${offset.getDate()}`
    
    if (format === 'fullmonth') {
        return `${day} ${FullMonths[offset.getMonth()]}, ${offset.getFullYear()}`
    }

    if (format === 'datetime') {
        return offset.toUTCString().replace('GMT', '').split(',')[1]
    }

    return offset.toISOString().split('T')[0]
}

export default formatDate